import { render, staticRenderFns } from "./ClinicInvoiceFormModal.vue?vue&type=template&id=4e4f7dd1&scoped=true&"
import script from "./ClinicInvoiceFormModal.vue?vue&type=script&lang=js&"
export * from "./ClinicInvoiceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ClinicInvoiceFormModal.vue?vue&type=style&index=0&id=4e4f7dd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f7dd1",
  null
  
)

export default component.exports